import { render, staticRenderFns } from "./perfilUsuarioGeral.vue?vue&type=template&id=29a1c7ea&scoped=true&"
import script from "./perfilUsuarioGeral.vue?vue&type=script&lang=js&"
export * from "./perfilUsuarioGeral.vue?vue&type=script&lang=js&"
import style0 from "./perfilUsuarioGeral.vue?vue&type=style&index=0&id=29a1c7ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a1c7ea",
  null
  
)

export default component.exports